module.exports = __webpack_public_path__ + "static/liva-web-7c6c4342203a7013831a7958583da226.jpg";